import React from 'react';
import { Box, Container, Divider, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { azureColors } from '../theme';

const sectionSx = { mb: 3 };

const PrivacyPolicyPage = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#F3F2F1' }}>
      <Header />
      <Container sx={{ flex: 1, py: 4, maxWidth: '860px' }}>
        <Typography variant="h3" gutterBottom sx={{ color: azureColors.primary }}>
          Privacy Policy
        </Typography>
        <Typography variant="body2" sx={{ color: azureColors.textSecondary, mb: 3 }}>
          Last updated: 24 July 2026 · Applies to this portfolio website operated by Mario Bozhinovski / Aldea Systems.
        </Typography>

        <Box sx={sectionSx}>
          <Typography variant="h5" gutterBottom>1. Who we are</Typography>
          <Typography variant="body1" paragraph>
            This site is a personal / business portfolio for Mario Bozhinovski (Aldea Systems). Contact:{' '}
            <Link href="mailto:contact@aldeasystems.com">contact@aldeasystems.com</Link>.
          </Typography>
        </Box>

        <Box sx={sectionSx}>
          <Typography variant="h5" gutterBottom>2. What data we collect</Typography>
          <Typography variant="body1" paragraph>
            <strong>Strictly necessary:</strong> we store your consent choice locally in your browser so we remember
            whether analytics is allowed.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Analytics (only after you accept):</strong> we may collect and store:
          </Typography>
          <Typography component="ul" variant="body1" sx={{ pl: 3 }}>
            <li>Page URL, path, title, and timestamp</li>
            <li>Referrer and UTM campaign parameters</li>
            <li>IP address and approximate geo location (country / region / city)</li>
            <li>Browser, OS, device type, language, screen/viewport size</li>
            <li>Network hints when available (connection type)</li>
            <li>Anonymous visitor/session identifiers generated in your browser</li>
            <li>Consent decision audit records (accept / reject)</li>
          </Typography>
          <Typography variant="body1" paragraph sx={{ mt: 2 }}>
            We do not intentionally collect names, emails, or form contents through analytics. Contact form messages
            are sent via your email client (mailto) and are not stored by the analytics service.
          </Typography>
        </Box>

        <Box sx={sectionSx}>
          <Typography variant="h5" gutterBottom>3. Why we collect it</Typography>
          <Typography variant="body1" paragraph>
            To understand traffic sources, popular pages, and technical environment so the portfolio and services can
            be improved. Legal basis under GDPR: your consent for analytics; legitimate interest / necessity for
            storing the consent record itself.
          </Typography>
        </Box>

        <Box sx={sectionSx}>
          <Typography variant="h5" gutterBottom>4. Where data is stored</Typography>
          <Typography variant="body1" paragraph>
            Analytics events are stored in a private SQLite database on infrastructure controlled by the site operator
            (Docker volume). Data is not sold to third-party advertisers.
          </Typography>
        </Box>

        <Box sx={sectionSx}>
          <Typography variant="h5" gutterBottom>5. Retention</Typography>
          <Typography variant="body1" paragraph>
            Visit and consent records are retained until deleted by the operator, or upon a valid erasure request
            where identification is reasonably possible.
          </Typography>
        </Box>

        <Box sx={sectionSx}>
          <Typography variant="h5" gutterBottom>6. Your choices & rights</Typography>
          <Typography variant="body1" paragraph>
            You can accept or reject analytics via the consent banner. You may change your mind later from the{' '}
            <Link component={RouterLink} to="/cookies">Cookie Policy</Link> page (reset consent). Depending on
            applicable law (e.g. GDPR/UK GDPR), you may have rights of access, rectification, erasure, restriction,
            objection, and complaint to a supervisory authority.
          </Typography>
        </Box>

        <Box sx={sectionSx}>
          <Typography variant="h5" gutterBottom>7. Cookies & similar technologies</Typography>
          <Typography variant="body1" paragraph>
            See the <Link component={RouterLink} to="/cookies">Cookie Policy</Link> for details.
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />
        <Typography variant="body2" color="text.secondary">
          This policy is provided for transparency and should be reviewed by counsel for your jurisdiction before
          production use outside personal experimentation.
        </Typography>
      </Container>
      <Footer />
    </Box>
  );
};

export default PrivacyPolicyPage;
